
import React, { useEffect, useState } from 'react';
import { getImage } from '../../helpers/indexedDbHelper';
import {useTranslation} from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import DetailProduct from './DetailProduct';

function Index({dishs, setShowListProduct, setScreen, setDataDish, setlocation}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const { menus, name: title } = dishs;

    const [showDetailProduct, setShowDetailProduct] = useState(false);


    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };


    const Item = ({ data }) => {
        const [image, setImage] = useState(false);
        useEffect(() => {
            fetchImage(`menu-image-${data.id}`).then((url) => {
                if (url) {
                    setImage(url);
                    
                }
            });
        }, []);
        
        return (
           <div onClick={()=>[setScreen('detailproduct'), setDataDish({ dish: data, alldish: menus, currentDish: dishs }), setlocation('list')]}  style={{
                backgroundColor: 'black', marginBottom: 30, textDecoration: 'none', 
                width: 260,
                maxHeight: 390,
                margin: '15px 0px',
                textAlign: 'left',
                paddingBottom: 40,
                position: 'relative',
                borderRadius: 14,
                border: '1px solid white'
            }}>
                <img src={image}  onContextMenu={(e) => e.preventDefault()}  style={{width: 260, height: 260, pointerEvents: 'none', objectFit: 'cover',  borderRadius: 14,}}/>
                <h3 style={
                    { fontFamily: "LondrinaSolidRegular", color: 'white', textTransform: 'uppercase', fontSize: 20, margin: 0, marginLeft: 10, marginTop: 10 }
                    }> {langEng ? data.name : translate(i18n.language, data.language, data.name)}</h3>
                
                <div style={{width: '100%', marginTop: 5}}>
                    <p
                        className='shor-text'
                        style={{ fontFamily: "LondrinaSolidLight",fontSize: 15, color: 'white', margin: 0,marginLeft: 10,}}>

                        {langEng ? 
                                    `${data.regular_decription.replace(/\\n/g,'\n')}`
                                : 
                                `${translateMenu(
                                    i18n.language, 
                                    data.language, 
                                    data.regular_decription, 
                                    'regular_decription'
                                )}`
                        }
                        
                        
                    </p>
                </div>

                <div style={{
                        paddingTop: 10,
                    paddingBottom: 5,
                    marginLeft: 10,
                    borderTop: '1px solid #fff',
                    marginTop: 20,
                        
                }}>
                    <div>
                        <p
                        style={
                           {color: '#fff', fontSize: 15, fontWeight: 'bold', margin: 0, fontWeight: '900'}
                        }>

                            {data.price > 0 &&
                            <> ${data.price.toFixed(2)}</>
                            }
                       
                        </p>
                    </div>
                    <div>
                        <div style={{flexDirection: 'row'}}>
                        </div>
                    </div>
                </div>
                
                
            </div>
        );
    }

    return (
        
            <div showBack={false}>
                <div>
                    <div style={{
                        zIndex: -1,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    
                    }}>
                        
                        <div onClick={()=>setScreen('home')} style={{
                            width: 200,
                            textAlign: 'center',
                            textDecoration: "none",
                            color: 'black',
                            position: 'absolute',
                            bottom: 30,
                            left: 22,
                            zIndex: 100,
                        }}>
                            <div
                                style={
                                    {
                                        borderRadius: 5,
                                        textAlign: 'center',
                                        padding: 2,
                                        backgroundColor: '#ff002c',
                                    }
                                }
                            >
                                <div
                                style={{
                                    padding: 10,
                                    paddingVertical: 15,
                                }}>
                                <p
                                        style={{
                                        fontFamily: "LondrinaSolidRegular",
                                        textAlign: 'center', 
                                        alignSelf: 'center',
                                        fontSize: 23,
                                        textTransform: 'uppercase',
                                            fontWeight: '900',
                                            color : 'white'
                                    
                                        }}>
                                        {langEng ? "Back": "Volver al menú"}
                                
                                </p>
                                </div>
                            </div>
                        </div>
                        
                    </div>


                    <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            padding: '0px 0px 100px 0px',
                            overflow: 'scroll',
                            height: 800,
                            
                        }}>
                            {menus.map((item, key) => (
                                <Item data={ item }  key={key} />
                            ))}
                        </div>   
                    
                
                </div>
                
            </div>
       
    );
}
export default Index;